import * as XLSX from "xlsx";

// Function to prepare data to export summary report
const prepareExcelDataForThirdPartyAuditReport = (data) => {
  const excelRows = [];

  let srNo = 1;
  data.forEach((audit) => {
    // Add parent row (Audit summary)
    excelRows.push({
      "Audit No": srNo,
      "Audit Id": audit.auditId,
      "Audit Type": audit.auditTypeName,
      "Status": audit.status,
      "Remark": audit.remark,
      "Total Activities": audit.totalActivitiesCount,
      "Total NC's": audit.totalNCActivitiesCount,
      "Closed NC's": audit.closedActivitiesCount,
      "Branch Name": audit.branchName,
      "Department Name": audit.departmentName,
      "Area Name": audit.areaName,
      "Created By": audit.createdByName,
      "Auditor Name": audit.auditorName,
      "Start Date": audit.readableStartDate,
      "End Date": audit.readableEndDate,
      "Created On": audit.createdAtForExcel,
      "Updated On": audit.updatedAtForExcel,
      "NC No": "",
      "Activity Name": "",
      "Observation By Auditor": "",
      "CAPA": "",
      "No Of Attachments": "",
    });

    // Add each NC Activity row below the parent
    (audit.ncActivities || []).forEach((activity, idx) => {
      excelRows.push({
        "Audit Id": "", // Optionally link to parent
        "Audit Type": "",
        "Status": "",
        "Remark": "",
        "Total Activities": "",
        "Total NC's": "",
        "Closed NC's": "",
        "Branch Name": "",
        "Department Name": "",
        "Area Name": "",
        "Created By": "",
        "Auditor Name": "",
        "Start Date": "",
        "End Date": "",
        "Created On": "",
        "Updated On": "",
        "NC No": idx + 1,
        "Activity Name": activity.activityName,
        "Observation By Auditor": activity.auditorObservation,
        "CAPA": activity.capa,
        "No Of Attachments": activity.attachments?.length,
      });
    });

    srNo++;
  });

  return excelRows;
};

// Export Summary Report data to excel
export const exportThirdPartyAuditReportDataToExcel = (data) => {
  const preparedData = prepareExcelDataForThirdPartyAuditReport(data);
  // Remove __rowType before export (optional)
  const cleanedData = preparedData.map(({ __rowType, ...row }) => row);
  const worksheet = XLSX.utils.json_to_sheet(cleanedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data Sheet");

  // Download the file
  XLSX.writeFile(workbook, `Third_Party_Audit_Report_${new Date().getTime()}.xlsx`);
};